import * as React from 'react'

import { GroupButton } from '~/client/src/shared/components/Filters/triggers'
import { GroupByPopover } from '~/client/src/shared/components/OptionsList'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import { getResourceDefinition } from '~/client/src/shared/resources/definitions'

import { useResourceFieldContext } from '../ResourceFieldContext'

function DefaultGroupBy(): JSX.Element {
  const {
    resourceTypeId,
    groupByKey,
    activePopup,
    groupByOptions,
    setGroupByDefault,
    closePopup,
    togglePopup,
  } = useResourceFieldContext()

  const isOpen = activePopup === 'groupBy'

  const handleOpenChange = React.useCallback(
    (open: boolean) => {
      if (!open) closePopup()
    },
    [closePopup],
  )

  const handleGroupByChange = React.useCallback(
    (key: string | null) => {
      setGroupByDefault(key)
    },
    [setGroupByDefault],
  )

  const triggerLabel = React.useMemo(() => {
    const base = Localization.translator.groupBy
    const selected = groupByKey
      ? groupByOptions.find(o => o.key === groupByKey)?.label
      : null
    return selected ? `${base}: ${selected}` : base
  }, [groupByKey, groupByOptions])

  return (
    <GroupByPopover
      open={isOpen}
      onOpenChange={handleOpenChange}
      side="right"
      options={groupByOptions}
      selectedKey={groupByKey}
      onChange={handleGroupByChange}
      // A resource with its own picker groupings always groups; left unset, it opens as
      // its picker default.
      allowNone={!getResourceDefinition(resourceTypeId)?.ui.pickerGroupings}
    >
      <GroupButton
        label={triggerLabel}
        onClick={() => togglePopup('groupBy')}
      />
    </GroupByPopover>
  )
}

export default DefaultGroupBy
